import { render, staticRenderFns } from "./ItemsListTypeSwitch.vue?vue&type=template&id=e74b931c&scoped=true"
import script from "./ItemsListTypeSwitch.vue?vue&type=script&lang=js"
export * from "./ItemsListTypeSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74b931c",
  null
  
)

export default component.exports